/*jslint node: true*/

"use strict";

var ko = require("pli/knockout");
var pli = require("pli/forms");

var SelectionFormViewModel = require("./selectionForm.js");
var selectionFormUtils = require("./selectionFormUtils.js");

var selectionForm = pli.forms.registry.selectionForm;
if (typeof selectionForm !== "object") { throw new Error("Selection form element could not be found - did you render it using CreateSelectionForm?"); }

selectionForm.viewModel = new SelectionFormViewModel(ko, pli, selectionForm);
selectionForm.utils = selectionFormUtils;

//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Exports
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

module.exports = selectionForm;



//////////////////
// WEBPACK FOOTER
// ./app/common-selectionform/index.js
// module id = 520
// module chunks = 49